import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  return (
    <div className="nf">
      <div className="nf__inner">
        <Link to="/" className="nf__brand display" aria-label="Bella 7 home">
          Bella <em>7</em>
        </Link>

        <h1 className="nf__heading display">
          404 —<br /><em>not here</em>.
        </h1>
        <p className="nf__intro">
          The page you're looking for has slipped through the cracks. Let's
          get you back to the salon.
        </p>

        <Link to="/" className="nf__cta">
          <span>Back to home</span>
          <span className="nf__arrow">→</span>
        </Link>
      </div>
    </div>
  );
}